import r from "./index85.mjs";
import { useEffect as S } from "react";
import { StorageKey as n } from "./index49.mjs";
import { useStorage as m } from "./index50.mjs";
import { CookiesEnum as o } from "./index48.mjs";
const c = (e) => {
  const t = r.get(o.PublicUserId);
  return `${n.SessionStorePrefix}${t ?? "shared"}:${e}`;
}, f = (e) => r.get(o.BrowserSessionActiveId) === e.toString(), v = (e, t = {}) => {
  const s = r.get(o.PublicUserId) ?? "shared", i = m(c(e), t);
  return S(() => {
    f(s) || (i.removeByPrefix(n.SessionStorePrefix), r.set(o.BrowserSessionActiveId, s.toString(), {
      sameSite: "strict",
      path: "/"
    }));
  }, [s, i.removeByPrefix]), i;
};
export {
  c as getSessionStoreKey,
  v as useSessionStore
};
